import styled from "styled-components";
import {Col, Select} from "antd";

export const Img = styled.img`
    height: 80px;
    display: flex;
    margin: auto;
    border-radius: 4px;
    border: 10px solid #fafafa;
    box-sizing: content-box;
`;
export const IconCol = styled(Col)`
    margin: auto 0;
    color: #ffffff;
    font-size: 20px;
    background: #009688;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
`;

export const SelectField = styled(Select)`
    .ant-select-selection-item {
        height: auto !important;
    }
`;
